import { supabase } from './supabase.js';
import { toCamel } from './case.js';

/**
 * Fetch active shopping items (not yet purchased).
 */
export async function fetchShoppingItems() {
  const { data, error } = await supabase
    .from('shopping_items')
    .select('*')
    .eq('purchased', false)
    .order('added_at', { ascending: false });
  if (error) {
    console.error('fetchShoppingItems error:', error);
    return [];
  }
  return toCamel(data);
}

/**
 * Add a new shopping item.
 * pairId can be null — that means a solo item, only visible to the current user.
 * When the user later partners up, solo items get adopted into the pair.
 */
export async function addShoppingItem(name, pairId) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Not logged in');

  const { data, error } = await supabase
    .from('shopping_items')
    .insert({
      pair_id: pairId || null,
      added_by: user.id,
      name,
    })
    .select()
    .single();
  if (error) throw error;
  return toCamel(data);
}

/**
 * Mark an item as purchased.
 */
export async function purchaseShoppingItem(itemId) {
  const { error } = await supabase
    .from('shopping_items')
    .update({ purchased: true, purchased_at: new Date().toISOString() })
    .eq('id', itemId);
  if (error) throw error;
}

/**
 * Delete a shopping item entirely.
 */
export async function deleteShoppingItem(itemId) {
  const { error } = await supabase
    .from('shopping_items')
    .delete()
    .eq('id', itemId);
  if (error) throw error;
}
